import { PropsWithChildren } from "react";

export default function ActivityWrapper({ children }: PropsWithChildren) {
  return <div className="relative flex flex-row gap-2 my-3">{children}</div>;
}
